import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { VariationCard } from './VariationCard';
import { AutoplayVariation } from '@/store/videoFeatures/types/autoplay-ab-test';
import { cn } from '@/lib/utils';

interface SortableVariationCardProps {
  variation: AutoplayVariation;
  isActive?: boolean;
  isPrimary?: boolean;
  trafficPercentage: number;
  onEdit: (variation: AutoplayVariation) => void;
  onDelete: (variationId: string) => void;
  canDelete?: boolean;
}

export const SortableVariationCard: React.FC<SortableVariationCardProps> = ({
  variation,
  ...props
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: variation.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn(
        isDragging && "opacity-50 z-50"
      )}
    >
      <VariationCard
        variation={variation}
        {...props}
      />
    </div>
  );
};
